import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: BASE });
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("pm_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const adminApi = axios.create({ baseURL: BASE });
adminApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("pm_admin_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function formatError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  if (detail && typeof detail.message === "string") return detail.message;
  return String(detail);
}

export const money = (n) => `£${Number(n || 0).toFixed(2)}`;
export const API_BASE = BASE;
